module.exports = require('./Coalition')